module.exports = __webpack_public_path__ + "img/chris_g_43.c16048e8.jpg";